export default function vendor() {
	return {
		id: undefined,
		r10Id: undefined,
		name: undefined,
		street: undefined,
		postalCode: undefined,
		countryCode: undefined,
		postalPlace: undefined,
		orgNo: undefined,
		type: undefined,
		vendorNumber: undefined,
		externalCustomerId: undefined,
		edipartId: undefined,
		serviceCode: undefined,
	};
}
